import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { IFormSection } from "../../types/common";
import { createViewAction, getForm, getRegister } from "../../utils/helpers";
import { URL_MERCHANT_IP_WHITELIST } from "../../utils/urls";
import useGet from "../common/useGet";
import {
  API_CUSTOMER_CONFIGURABLE_MERCHANTS,
  API_MERCHANT_IP_WHITELIST,
} from "../../utils/apis";

const url = URL_MERCHANT_IP_WHITELIST;

export const useMerchantIPWhitelist = () => {
  const tableColumns = () => [
    {
      id: "merchant_name",
      header: "Merchant Name",
      filter: { type: "text" },
    },
    {
      id: "merchant_code",
      header: "Merchant Code",
      filter: { type: "text" },
    },
    {
      id: "ip_address",
      header: "IP Address",
      filter: { type: "text" },
    },
    {
      id: "is_active",
      header: "ActiveStatus",
      filter: {},
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_active: <BooleanTags status={item?.is_active} />,
        actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Merchant Codes Payments Details",
          fields: {
            merchant_code: item?.merchant_code,
            ip_address: item?.ip_address,
            is_active: <BooleanTags status={item?.is_active} />,
            merchant_name: item?.merchant_name,
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  return { tableColumns, tableData, viewData, formRoute };
};

export const useMerchantIPWhitelistForm = ({ form }) => {
  const {
    loadData: getConfigurableMerchants,
    data: configurableMerchants,
    loading: configurableMerchantsLoading,
  } = useGet();

  useEffect(() => {
    getConfigurableMerchants({ api: API_CUSTOMER_CONFIGURABLE_MERCHANTS });
  }, []);
  const sections: IFormSection[] = [
    {
      title: "Merchant IP Whitelist Details",
      fields: [
        {
          field_name: "merchant_name",
          label: "Merchant Name",
          type: "select",
          props: {
            required: true,
          },
          options_data: configurableMerchants?.map((item: any) => ({
            id: item?.id,
            name: item?.name,
            extraFields: {
              merchant_code: item.id,
            },
          })),
        },
        {
          field_name: "merchant_code",
          label: "Merchant Code",
          type: "text",
          props: {
            required: true,
            disabled: true,
            value: form?.merchant_code || "",
          },
        },
        {
          field_name: "ip_address",
          label: "IP Address",
          type: "text",
          props: {
            required: true,
          },
        },
        {
          field_name: "is_active",
          label: "Active Status",
          type: "select",
          props: {
            required: true,
            options: [
              { value: true, label: "Active" },
              { value: false, label: "Inactive" },
            ],
          },
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  return {
    sections,
    configurableMerchantsLoading,
    configurableMerchants,
    onSubmit: submitMerchantIPWhitelist,
    redirect,
  };
};

// SUBMIT
export function submitMerchantIPWhitelist(payload: any, id: string | number) {
  //   UPDATE
  if (id) {
    return {
      api: `${API_MERCHANT_IP_WHITELIST}${id}/`,
      params: {
        ...payload,
      },
    };
  }

  //   CREATE
  return {
    api: `${API_MERCHANT_IP_WHITELIST}`,
    params: {
      ...payload,
    },
  };
}
